import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import CustomMultiSelect from 'src/utils/CustomMultiSelect';
import { ReactComponent as DropdownIcon } from 'src/Images/icons/common/dropdown.svg';
import getColorCode from 'src/utils/GetThemeColor';
import 'src/style/createVehicleTracking.css';

function BasicDetails({
  formData,
  handleOnChange,
  errorField,
  outwardVehicleTrackingDetails,
  workflowDataOption,
  plantDataOptions,
}) {
  const authReducer = useSelector((state) => state.AuthReducer);
  const themeColor = authReducer?.userData?.tenant?.theme;

  return (
    <div className="create-form-container form-input-container">
      <Row className="create-form-row">
        <Col
          className={`theme-scrollable-container-${themeColor} scrollable-container`}
        >
          <Row className="py-2">
            <span className="text-lg text-semi-bold">Select Workflow</span>
          </Row>
          <Row>
            <Col xxl={4} xl={4} lg={4} md={4}>
              <div className="div-flex-column">
                <div className="div-flex-row cg-5">
                  <span className="text-sm text-bold">Workflow</span>
                </div>
                <div className="input-wrapper">
                  <CustomMultiSelect
                    name="workflowId"
                    isMulti={false}
                    className={`margin-top-5 ${
                      errorField.workflowId
                        ? 'react-select-input-error'
                        : 'multi-select-input-section'
                    }`}
                    onChange={(selectedOption) => {
                      handleOnChange({
                        target: {
                          name: 'workflowId',
                          value: selectedOption?.value || null,
                        },
                      });
                    }}
                    options={workflowDataOption}
                    classNamePrefix="react-select"
                    placeholder="Select Workflow"
                    value={workflowDataOption.find(
                      (option) => option.value === formData.workflowId,
                    )}
                  />
                  <span className="form-input-section-icon">
                    <DropdownIcon
                      className="icon-size-sm"
                      color={getColorCode(themeColor)}
                    />
                  </span>
                </div>
                {errorField.workflowId && (
                  <span className="text-sm text-red">
                    This field is required
                  </span>
                )}
              </div>
            </Col>
            <Col xxl={4} xl={4} lg={4} md={4}>
              <div className="div-flex-column">
                <div className="div-flex-row cg-5">
                  <span className="text-sm text-bold">Plant</span>
                </div>
                <div className="input-wrapper">
                  <CustomMultiSelect
                    name="plantId"
                    isMulti={false}
                    className="margin-top-5 multi-select-input-section"
                    onChange={(selectedOption) => {
                      handleOnChange({
                        target: {
                          name: 'plantId',
                          value: selectedOption?.value || null,
                        },
                      });
                    }}
                    options={plantDataOptions}
                    classNamePrefix="react-select"
                    placeholder="Select Plant"
                    value={
                      plantDataOptions.find(
                        (option) => option.value === formData.plantId,
                      ) || null
                    }
                  />
                  <span className="form-input-section-icon">
                    <DropdownIcon
                      className="icon-size-sm"
                      color={getColorCode(themeColor)}
                    />
                  </span>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="py-3 border-top mt-2">
            <span className="text-lg text-semi-bold">Vehicle Inputs</span>
          </Row>
          <Row>
            <Col xxl={4} xl={4} lg={4} md={4} className="form-input-container">
              <div className="div-flex-column">
                <div className="div-flex-row">
                  <span className="text-sm text-bold">Name</span>
                </div>
                <div className="text-sm text-grey">
                  {outwardVehicleTrackingDetails?.vehicleDetails?.driver_name ||
                    'N/A'}
                </div>
              </div>
            </Col>
            <Col xxl={4} xl={4} lg={4} md={4} className="form-input-container">
              <div className="div-flex-column">
                <div className="div-flex-row">
                  <span className="text-sm text-bold">Mobile Number</span>
                </div>
                <div className="text-sm text-grey">
                  {outwardVehicleTrackingDetails?.vehicleDetails
                    ?.driver_mobile_number || 'N/A'}
                </div>
              </div>
            </Col>
            <Col xxl={4} xl={4} lg={4} md={4} className="form-input-container">
              <div className="div-flex-column">
                <div className="div-flex-row">
                  <span className="text-sm text-bold">License Number</span>
                </div>
                <div className="text-sm text-grey">
                  {outwardVehicleTrackingDetails?.vehicleDetails
                    ?.driving_license_number || 'N/A'}
                </div>
              </div>
            </Col>
            <Col xxl={4} xl={4} lg={4} md={4} className="form-input-container">
              <div className="div-flex-column">
                <div className="div-flex-row">
                  <span className="text-sm text-bold">License Validity</span>
                </div>
                <div className="input-wrapper">
                  <div className="text-sm text-grey">
                    {outwardVehicleTrackingDetails?.vehicleDetails
                      ?.driver_license_validity || 'N/A'}
                  </div>
                </div>
              </div>
            </Col>
            <Col xxl={4} xl={4} lg={4} md={4} className="form-input-container">
              <div className="div-flex-column">
                <div className="div-flex-row">
                  <span className="text-sm text-bold">COA</span>
                </div>
                <div className="text-sm text-grey">
                  {outwardVehicleTrackingDetails?.vehicleDetails?.test_report ||
                    'N/A'}
                </div>
              </div>
            </Col>
            <Col xxl={4} xl={4} lg={4} md={4} className="form-input-container">
              <div className="div-flex-column">
                <div className="div-flex-row">
                  <span className="text-sm text-bold">Container Number</span>
                </div>
                <div className="text-sm text-grey">
                  {outwardVehicleTrackingDetails?.vehicleDetails
                    ?.container_number || 'N/A'}
                </div>
              </div>
            </Col>
            <Col xxl={4} xl={4} lg={4} md={4} className="form-input-container">
              <div className="div-flex-column">
                <div className="div-flex-row">
                  <span className="text-sm text-bold">Weight Slip</span>
                </div>
                <div className="input-wrapper">
                  <div className="text-sm text-grey">
                    {outwardVehicleTrackingDetails?.vehicleDetails
                      ?.weight_slip || 'N/A'}
                  </div>
                </div>
              </div>
            </Col>
            <Col xxl={4} xl={4} lg={4} md={4} className="form-input-container">
              <div className="div-flex-column">
                <div className="div-flex-row">
                  <span className="text-sm text-bold">Remarks</span>
                </div>
                <div className="input-wrapper">
                  <div className="text-sm text-grey">
                    {outwardVehicleTrackingDetails?.vehicleDetails?.remarks ||
                      'N/A'}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="py-3 border-top mt-2">
            <span className="text-lg text-semi-bold">Vehicle Details</span>
          </Row>
          <Row>
            <Col xxl={3} xl={3} lg={3} md={3} className="form-input-container">
              <div className="div-flex-column">
                <div className="div-flex-row">
                  <span className="text-sm text-bold">Tank Condition</span>
                </div>
                <div className="input-wrapper">
                  <div className="text-sm text-grey">
                    {outwardVehicleTrackingDetails?.vehicleDetails
                      ?.tank_condition?.name || 'N/A'}
                  </div>
                </div>
              </div>
            </Col>
            <Col xxl={3} xl={3} lg={3} md={3} className="form-input-container">
              <div className="div-flex-column">
                <div className="div-flex-row">
                  <span className="text-sm text-bold">Information Panel</span>
                </div>
                <div className="input-wrapper">
                  <div className="text-sm text-grey">
                    {outwardVehicleTrackingDetails?.vehicleDetails
                      ?.information_panel?.name || 'N/A'}
                  </div>
                </div>
              </div>
            </Col>
            <Col xxl={3} xl={3} lg={3} md={3} className="form-input-container">
              <div className="div-flex-column">
                <div className="div-flex-row">
                  <span className="text-sm text-bold">Lid Condition</span>
                </div>
                <div className="input-wrapper">
                  <div className="text-sm text-grey">
                    {outwardVehicleTrackingDetails?.vehicleDetails
                      ?.lid_condition?.name || 'N/A'}
                  </div>
                </div>
              </div>
            </Col>
            <Col xxl={3} xl={3} lg={3} md={3} className="form-input-container">
              <div className="div-flex-column">
                <div className="div-flex-row">
                  <span className="text-sm text-bold">Tyre Condition</span>
                </div>
                <div className="input-wrapper">
                  <div className="text-sm text-grey">
                    {outwardVehicleTrackingDetails?.vehicleDetails
                      ?.tyre_condition?.name || 'N/A'}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="padding-top-10">
            <Col xxl={3} xl={3} lg={3} className="form-input-container">
              <div className="div-flex-row cg-5">
                <input
                  name="tremCard"
                  type="checkbox"
                  checked={
                    outwardVehicleTrackingDetails?.vehicleDetails?.trem_card ||
                    false
                  }
                  disabled
                />
                <span className="text-sm text-bold">TREM Card</span>
              </div>
            </Col>
            <Col xxl={3} xl={3} lg={3} className="form-input-container">
              <div className="div-flex-row cg-5">
                <input
                  name="reflectors"
                  type="checkbox"
                  checked={
                    outwardVehicleTrackingDetails?.vehicleDetails?.reflectors ||
                    false
                  }
                  disabled
                />
                <span className="text-sm text-bold">Reflectors</span>
              </div>
            </Col>
            <Col xxl={3} xl={3} lg={3} className="form-input-container">
              <div className="div-flex-row cg-5">
                <input
                  name="safetyHelmet"
                  type="checkbox"
                  checked={
                    outwardVehicleTrackingDetails?.vehicleDetails
                      ?.safety_helmet || false
                  }
                  disabled
                />
                <span className="text-sm text-bold">Safety Helmet</span>
              </div>
            </Col>
            <Col xxl={3} xl={3} lg={3} className="form-input-container">
              <div className="div-flex-row cg-5">
                <input
                  name="safetyShoes"
                  type="checkbox"
                  checked={
                    outwardVehicleTrackingDetails?.vehicleDetails
                      ?.safety_shoes || false
                  }
                  disabled
                />
                <span className="text-sm text-bold">Safety Shoes</span>
              </div>
            </Col>
            <Col xxl={3} xl={3} lg={3} className="form-input-container">
              <div className="div-flex-row cg-5">
                <input
                  name="safetyHandgloves"
                  type="checkbox"
                  checked={
                    outwardVehicleTrackingDetails?.vehicleDetails
                      ?.safety_handgloves || false
                  }
                  disabled
                />
                <span className="text-sm text-bold">Safety Handgloves</span>
              </div>
            </Col>
            <Col xxl={3} xl={3} lg={3} className="form-input-container">
              <div className="div-flex-row cg-5">
                <input
                  name="safetyGoggles"
                  type="checkbox"
                  checked={
                    outwardVehicleTrackingDetails?.vehicleDetails
                      ?.safety_goggles || false
                  }
                  disabled
                />
                <span className="text-sm text-bold">Safety Goggles</span>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
}

export default BasicDetails;
